import { stringify } from 'qs';
import { routerActions } from 'connected-react-router';

import * as utils from './utils';
import * as util from './../../../util';

export const createFiltersOperations = (actions, selectors, operations, api = {}) => ({
  restoreFilters: () => (dispatch, getState) => {
    const defaultOwners = selectors.getDefaultOwners(getState());
    const partialState = selectors.getParsedFiltersFromURL(getState(), { defaultOwners });
    return dispatch(actions.setFiltersFromURL(partialState));
  },
  updateURLWithFilters: (payload, method) => (dispatch, getState) => {
    const { filtersQuery, query } = selectors.getFiltersQuery(getState())(payload, method);
    const location = selectors.getLocation(getState());

    util.storeFilters(filtersQuery, location.pathname);

    return dispatch(routerActions.replace({ search: stringify(query, { arrayFormat: 'repeat' }) }));
  },
  clearAndGetFilters: (payload, meta) => (dispatch, getState) => {
    const filtersState = selectors.filtersSelector(getState());
    dispatch(actions.clearSelectedFilters());
    dispatch(operations.updateURLWithFilters(filtersState.filters, utils.clearFiltersQuery));
    return dispatch(operations.fetchFilters(meta));
  },
  selectAndGetFilterItems: (payload, meta) => (dispatch) => {
    dispatch(actions.selectFilterItems(payload));
    dispatch(operations.updateURLWithFilters(payload, utils.updateFiltersQuery));
    return dispatch(operations.fetchFilters(meta));
  },
  removeFilterItem: (payload, meta) => (dispatch) => {
    dispatch(actions.removeFilterItem(payload));
    dispatch(operations.updateURLWithFilters(payload, utils.removeFromFiltersQuery));
    return dispatch(operations.fetchFilters(meta));
  },
  selectDateFilter: (payload, meta) => (dispatch) => {
    dispatch(actions.selectDateFilter(payload));
    dispatch(operations.updateURLWithFilters(payload, utils.updateFiltersQueryWithDate));
    return dispatch(operations.fetchFilters(meta));
  },
  fetchUsers: () => (dispatch, getState) => (
    dispatch(actions.fetchUsers(selectors.getUsersParams(getState())))
  ),
  searchMetadata: (payload) => (dispatch, getState) => {
    const { filterKey, value } = payload;
    const isQueryValid = value && value.length > 2;
    if (api.fetchFilters && !isQueryValid) {
      return Promise.resolve();
    }

    // Update loading state and search value for the searchmeta
    dispatch(actions.searchMetadataRequest(payload));

    // Owners are not a part of the filters API, handle separately.
    if (filterKey === 'owner') {
      return dispatch(actions.fetchUsers(selectors.getUsersParams(getState())))
        .then(() => dispatch(actions.searchMetadataSuccess({ filterKey })))
        .catch(() => dispatch(actions.searchMetadataFailure(filterKey)));
    }

    return api.fetchFilters(selectors.getMetadataParams(getState(), payload))
      .then(({ data }) => dispatch(actions.searchMetadataSuccess({ filterKey, data })))
      .catch(() => dispatch(actions.searchMetadataFailure(filterKey)));
  },
  initialize: (meta) => (dispatch, getState) => (
    Promise.all([
      dispatch(actions.initialize(selectors.getBasicOwners(getState()))),
      dispatch(actions.fetchUsers()),
      dispatch(actions.fetchTeams()),
    ])
      .then(() => dispatch(operations.restoreFilters()))
      .then(() => dispatch(operations.fetchFilters(meta)))
      .then(() => (
        dispatch(operations.updateURLWithFilters(
          selectors.getFilters(getState()),
          utils.setupFiltersQuery,
        ))
      ))
  ),
});
